Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var lurkerSend = function lurkerSend(event_type, object_name, object_detail) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var payload = Object.assign({
    event_type: event_type,
    object_name: object_name,
    object_detail: object_detail
  }, data);
  console.log("CONTENT-MOD LURKER WEB: ".concat(JSON.stringify(payload)));
  if (!window.Lurker) {
    window.beforeLurkerLoadEvents = window.beforeLurkerLoadEvents || [];
    window.beforeLurkerLoadEvents.push(payload);
    return;
  }
  window.Lurker.send(payload)["catch"](console.error);
};
var sendClickRate = function sendClickRate(objDetaildurker, lurkerObjName, extras) {
  return lurkerSend('click', lurkerObjName || 'chat', objDetaildurker, Object.assign({}, extras));
};
var loadStorageError = function loadStorageError(value, exception, objDetaildurker) {
  return lurkerSend('error', objDetaildurker, 'storage', {
    value: value,
    exception: "".concat(exception)
  });
};
var _default = {
  sendClickRate: sendClickRate,
  loadStorageError: loadStorageError
};
exports["default"] = _default;